import $ from 'cash-dom'

export default {
  install (Vue) {

    Vue.directive('landing-hover', {
      mounted(el, binding) {
        
        const $parentEl = $(binding.value.parentEl)
        const $el = $(el)

        $el.on('mouseover', function () {
          $parentEl.addClass('isActive')
        })
        $el.on('mouseout', function () {
          $parentEl.removeClass('isActive')
        })
      },

      updated () {
      }
    })
  }
}
